import React, { useState, useEffect, useCallback } from 'react';
import { withTranslation } from '../../../ChildrenContext.js';
import PropTypes from 'prop-types';
import DataComponentFinanceBlock from '../../../DataComponent/DataComponentFinanceBlock';

export const OperationHistoryPageContainer = ({
    accountEntries: propAccountEntries,
    headerNames: propHeaderNames,
    totalPages: propTotalPages,
    loading: propLoading,
    selectOptions: propSelectOptions,
    getAccountEntries: propGetAccountEntries,
    t
}) => {
    const [accountEntries, setAccountEntries] = useState(propAccountEntries);
    const [headerNames, setHeaderNames] = useState(propHeaderNames);
    const [totalPages, setTotalPages] = useState(propTotalPages);
    const [loading, setLoading] = useState(propLoading);

    useEffect(() => {
        setAccountEntries(propAccountEntries);
        setTotalPages(propTotalPages);
        setLoading(propLoading);
    }, [propAccountEntries, propTotalPages, propLoading]);

    const lastSignatureRef = React.useRef(null);

    const onDataTableAction = useCallback((state) => {
        const normalized = {
            ...state,
            page: state.page || 1
        };
        const signature = JSON.stringify(normalized);
        if (signature === lastSignatureRef.current) {
            return;
        }
        lastSignatureRef.current = signature;
        propGetAccountEntries(normalized);
    }, [propGetAccountEntries]);

    const staticNames = t?.dataTable || {};

    return (
        <DataComponentFinanceBlock
            onAction={onDataTableAction}
            totalPages={totalPages}
            headerNames={headerNames}
            data={accountEntries}
            loading={loading}
            isQuery={true}
            className="simple-table payout-table"
            gray={true}
            fields={[
                {
                    name: 'datepicker',
                    key: 'create',
                    label: staticNames.headers?.createdAt,
                    dropdownLabel: staticNames.filter,
                    disabled: true,
                    withTimezone: true,
                },
                {
                    name: 'multiselect',
                    key: 'sources',
                    data: propSelectOptions,
                    label: staticNames.headers?.reason,
                    dropdownLabel: staticNames.filter,
                    placeholder: staticNames.tips?.byReason
                }
            ]}
        />
    );
};

OperationHistoryPageContainer.propTypes = {
    accountEntries: PropTypes.array,
    headerNames: PropTypes.array,
    totalPages: PropTypes.number,
    loading: PropTypes.bool,
    selectOptions: PropTypes.array,
    getAccountEntries: PropTypes.func,
    t: PropTypes.object
};

OperationHistoryPageContainer.defaultProps = {
    accountEntries: [],
    headerNames: [],
    totalPages: 0,
    loading: false,
    selectOptions: [],
    getAccountEntries: () => {}
};

export default withTranslation(OperationHistoryPageContainer);
